import React, { useState } from 'react';
import styles from './ImageHeaderMenuSelector.module.css';
import { addTrainingRedux } from '../../store/slices/menuSlice';
import { useDispatch, useSelector } from 'react-redux';
import { addSettingsApplicationRedux } from '../../store/slices/settingsApplicationSlice';

const objImges = [
  {
    id: 'K1B7F695Y5b9I032c4P3L1H5F2Ty',
    createdAt: 1765590243152,
    url: 'https://firebasestorage.googleapis.com/v0/b/bd-nk-f16fd.firebasestorage.app/o/uploads%2F1765590242386_cat.jpg?alt=media&token=b7b03b0c-683f-4d4b-bb71-993b3967b548',
    title: 'Зображення 2',
    size: {
      label: 'КБ',
      value: 11,
      size: 11678,
    },
    description: 'ллвл',
    fileType: 'image',
  },
];

export default function ImageHeaderMenuSelector() {
  const dispatch = useDispatch();
  const allFiles = useSelector((state) => state.files.files);
  const selected = useSelector(
    (state) => state.settingsApplication.settingsApplication.menuHeaderImages,
  );
  const images = (allFiles || []).filter((file) => file.fileType === 'image');

  const [open, setOpen] = useState(false);

  const handleSelect = (item) => {
    dispatch(
      addSettingsApplicationRedux({
        key: 'settingsApplication',
        subKey: 'menuHeaderImages',
        value: item,
      }),
    );
    setOpen(false);
  };

  const handleRemove = () => {
    dispatch(
      addSettingsApplicationRedux({
        key: 'settingsApplication',
        subKey: 'menuHeaderImages',
        value: null,
      }),
    );
  };

  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>Вибрати зображення для шапки меню</h3>
      <button className={styles.button} onClick={() => setOpen(!open)}>
        {selected ? selected.title : 'Вибрати зображення'}
      </button>

      <div className={`${styles.dropdown} ${open ? styles.open : styles.closed}`}>
        {images.length ? (
          images.map((item) => (
            <div
              key={item.id}
              className={`${styles.item} ${selected?.id === item.id ? styles.active : ''}`}
              onClick={() => handleSelect(item)}>
              <strong>{item.title}</strong>
              <p className={styles.description}>{item.description}</p>
            </div>
          ))
        ) : (
          <div className={styles.item}>Зображень не знайдено!</div>
        )}
      </div>

      {selected && (
        <div className={styles.selectedBox}>
          <div className={styles.menu_header}>
            <div
              className={styles.menu_header_image}
              style={{
                backgroundImage: `url(${selected.url})`,
              }}></div>
          </div>
          <button className={styles.removeBtn} onClick={handleRemove}>
            Видалити зображення
          </button>
        </div>
      )}
    </div>
  );
}
